<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
document.querySelector('#app').classList.add('overflow-hidden')
</script>

<template>
  <div class="section section_gray section_indents lg:pb-[150px]">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
          <h2 class="title-h2 mb-6">
            Ответы на&nbsp;самые популярные вопросы по&nbsp;trade-in
          </h2>
          <accordion>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Какие условия покупки автомобиля в трейд-ин?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Основное требование — юридическая чистота. Программа трейд-ин
                  предполагает покупку автомобиля, на котором нет арестов,
                  залогов и прочих ограничений. Неоплаченные штрафы и другие
                  задолженности тоже могут стать препятствием. У вашего
                  транспортного средства должны быть читаемые номера кузова,
                  двигателя и шасси, совпадающие с информацией в свидетельстве о
                  регистрации (СТС).
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Как оценивается техническое состояние автомобиля?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Он должен быть полностью комплектным и передвигаться
                  собственными силами. Мелкие поломки и повреждения кузова не
                  будут помехой для выкупа, но снизят стоимость. Единых
                  стандартов нет — решение будут принимать специалисты на месте.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Какие документы нужны для сдачи автомобиля в трейд-ин?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Паспорт владельца автомобиля. Паспорт транспортного средства.
                  Свидетельство о регистрации транспортного средства.
                  Доверенность, если старую машину продает и новую покупает не
                  собственник.
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>

        <div class="relative hidden lg:block w-full lg:w-1/3 xl:w-1/4">
          <div
            class="static lg:absolute top-0 left-0 w-full lg:w-[calc(100%+(100vw-890px)/2)] xl:w-[calc(100%+(100vw-1140px)/2)] 2xl:w-[calc(100%+(100vw-1220px)/2)] h-full flex items-start justify-center"
          >
            <img
              class="w-full sm:w-10/12 lg:w-full max-w-[650px] h-auto"
              src="/public/images/pages/vikup/image-35.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
